import { useEffect, useState } from 'react';
import { API_URL } from '../../config';

/* Chiffres affichés sur le site (modifiables dans l'admin → 🏗️ Réalisations → « Chiffres du site ») */
export const DEFAUT = { mwc: '55 MWc', mwc_label: 'installés par nos équipes', annee: '10 ans', offre: '12 à 15 jours', offre_label: 'pour 500 kWc posés', chiffrage: '48 h', zone: 'France entière', google_note: '', google_nb: '', google_url: '', instagram: '' };

let cache = null;
export function fetchSettings() {
  if (!cache) {
    cache = fetch(API_URL + '/extras/site-settings')
      .then(r => (r.ok ? r.json() : {}))
      .then(d => ({ ...DEFAUT, ...(d && typeof d === 'object' ? d : {}) }))
      .then(d => ({ ...d, mwc: /^\s*9\s*MW/i.test(String(d.mwc || '')) ? '55 MWc' : d.mwc, mwc_label: String(d.mwc_label || '').replace(/\s*depuis\s+20\d\d/i, '') || 'installés' }))
      .catch(() => { cache = null; return DEFAUT; });
  }
  return cache;
}

export function useSiteSettings() {
  const [s, setS] = useState(DEFAUT);
  useEffect(() => { let ok = true; fetchSettings().then(d => ok && setS(d)); return () => { ok = false; }; }, []);
  return s;
}
